module.exports = __webpack_public_path__ + "img/rea2.5dd02fe0.jpeg";